<template>
  <header class="app-header">
    <div class="header-avatar-wrap">
      <img
        v-if="avatarUrl && !avatarError"
        class="header-avatar"
        :src="avatarUrl"
        alt="用户头像"
        @error="avatarError = true"
      />
      <div
        v-show="avatarError"
        class="header-avatar header-avatar--fallback"
      >
        {{ avatarText }}
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader'
}
</script>

<script setup>
import { ref, computed } from 'vue'
import { getUser } from '@/utils/auth'

const avatarError = ref(false)
const user = computed(() => getUser())
const avatarUrl = computed(() => user.value && user.value.avatar ? user.value.avatar : '')

const avatarText = computed(() => {
  const name = user.value && user.value.name ? user.value.name : '地'
  return name.charAt(0).toUpperCase()
})
</script>

<style scoped>
.app-header {
  position: fixed;
  top: 0;
  left: 236px;
  right: 0;
  z-index: 1000;
  height: 59px;
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 12px 32px;
  gap: 17.68px;
  box-sizing: border-box;
}

.header-avatar-wrap {
  flex: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 0 0 24px;
  width: 56px;
  height: 32px;
  box-sizing: border-box;
}

.header-avatar {
  flex: none;
  width: 32px;
  height: 32px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-sizing: border-box;
  object-fit: cover;
  display: block;
}

.header-avatar--fallback {
  background: #057bfa;
  color: #fff;
  font-family: 'HarmonyOS Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
  text-align: center;
}
</style>
